import React from 'react';
import { FormCheckbox, FormLabel } from '../common/forms/FormElements';
import { FormGroup, Input } from 'reactstrap';
import { isEndDateValid, isReadOnly } from './TimeOffRequest';

export default class TimeOffRequestDateRange extends React.Component {
    onHalfDayChanged = (e) => {
        const { timeOffRequest, onTimeOffRequestMutated } = this.props;

        timeOffRequest.isHalfDay = e.target.checked;

        if (timeOffRequest.isHalfDay) {
            timeOffRequest.endDate = null;
        }

        onTimeOffRequestMutated(timeOffRequest);
    };

    onStartDateChanged = (e) => {
        const { timeOffRequest, onTimeOffRequestMutated } = this.props;

        timeOffRequest.startDate = e.target.value;

        onTimeOffRequestMutated(timeOffRequest);
    };

    onEndDateChanged = (e) => {
        const { timeOffRequest, onTimeOffRequestMutated } = this.props;

        timeOffRequest.endDate = e.target.value;

        onTimeOffRequestMutated(timeOffRequest);
    };

    render() {
        const { loading, timeOffRequest } = this.props;

        if (loading) {
            return null;
        }

        const readOnly = isReadOnly(timeOffRequest);

        return (
            <>
                <FormGroup className="mr-3 tor-form-group">
                    <FormLabel text="Half Day" />

                    <FormCheckbox
                        checked={timeOffRequest.isHalfDay}
                        text="Half Day"
                        onChange={this.onHalfDayChanged}
                        disabled={readOnly}
                    />
                </FormGroup>
                <FormGroup className="mr-3 tor-form-group">
                    <FormLabel
                        text={timeOffRequest.isHalfDay ? 'Date' : 'Start Date'}
                        required
                    />

                    <Input
                        type="date"
                        value={timeOffRequest.startDate}
                        onChange={this.onStartDateChanged}
                        readOnly={readOnly}
                    />
                </FormGroup>

                {!timeOffRequest.isHalfDay && (
                    <FormGroup className="mr-3 tor-form-group">
                        <FormLabel text="End Date" />

                        <Input
                            type="date"
                            value={timeOffRequest.endDate}
                            onChange={this.onEndDateChanged}
                            readOnly={readOnly}
                            invalid={!isEndDateValid(timeOffRequest)}
                        />
                    </FormGroup>
                )}
            </>
        );
    }
}
